exports = module.exports = require("../../../../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-preview{\n    width: 1250px;\n    height: 400px;\n    border:1px solid rgb(202, 202, 202);\n    border-radius: 5px 5px 5px 5px;\n    background-color:rgb(185, 185, 185);\n    overflow: scroll;\n    padding:0px;\n}\n.img-preview-img{\n    width: 1250px;\n    height: 400px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/admin/page/slide-brand/slide-brand.component.css
// module id = ../../../../../src/app/admin/page/slide-brand/slide-brand.component.css
// module chunks = main